import styled from "styled-components";

export const Container = styled.div`
  background: rgba(201, 228, 55, 1);
  height: 1000px;
  line-height: 160px;
  text-align: center;
  width: 100%;
`;
